import { combineReducers } from '@reduxjs/toolkit';

import authReducer from './auth/AuthSlice';
import { apiServices } from 'services/RtkServices';
import MasterReducer from './MasterSlice';

export const RootReducer = combineReducers({
  auth: authReducer,
  master: MasterReducer,
  [apiServices.reducerPath]: apiServices.reducer
});
